// VRG-705 — one table cell for a last-activity moment: the date and time on top, how long ago
// underneath, the full stamp and zone on hover. Extracted from Tracked links' "Last click"
// (VRG-703) on its second use (People "Last seen" / "Last visit"), so the columns cannot drift.
import { Stack, Typography } from '@mui/material'
import { EMPTY_VALUE } from '@repo/ui'

import { activityStamp } from 'utils/date'

export const ActivityTimeCell = ({
  at,
  color = 'text.primary',
}: {
  at: string | null | undefined
  /** The primary line's colour; the relative line is always secondary. */
  color?: string
}) => {
  const stamp = activityStamp(at)
  return (
    <Stack justifyContent="center" sx={{ height: '100%', minWidth: 0 }} title={stamp?.title}>
      {stamp ? (
        <>
          <Typography variant="body2" color={color} noWrap>
            {stamp.primary}
          </Typography>
          <Typography variant="body3" color="text.secondary" noWrap>
            {stamp.relative}
          </Typography>
        </>
      ) : (
        <Typography variant="body2" color="text.disabled" noWrap>
          {EMPTY_VALUE}
        </Typography>
      )}
    </Stack>
  )
}
